/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Email_ExistsInputs */

const en_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account with this email already exists.`)
};

const fr_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un compte avec cet email existe déjà.`)
};

const de_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diese E-Mail-Adresse existiert bereits ein Konto.`)
};

const it_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esiste già un account con questo indirizzo email.`)
};

const ru_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учетная запись с этим адресом электронной почты уже существует.`)
};

const es_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya existe una cuenta con este correo electrónico.`)
};

const zh_cn2_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此邮箱地址已存在账户。`)
};

const ja_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このメールアドレスのアカウントは既に存在します。`)
};

const hi_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ईमेल पते से पहले से ही एक खाता मौजूद है।`)
};

const pt_pt2_login_error_email_exists = /** @type {(inputs: Login_Error_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe uma conta com este endereço de e-mail.`)
};

/**
* | output |
* | --- |
* | "An account with this email already exists." |
*
* @param {Login_Error_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_email_exists = /** @type {((inputs?: Login_Error_Email_ExistsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Email_ExistsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_email_exists(inputs)
	if (locale === "de") return de_login_error_email_exists(inputs)
	if (locale === "it") return it_login_error_email_exists(inputs)
	if (locale === "ru") return ru_login_error_email_exists(inputs)
	if (locale === "es") return es_login_error_email_exists(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_email_exists(inputs)
	if (locale === "ja") return ja_login_error_email_exists(inputs)
	if (locale === "hi") return hi_login_error_email_exists(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_email_exists(inputs)
	return en_login_error_email_exists(inputs)
});